import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { ChangePassword, ExpandableChangePasswordForm } from 'record-it-components/form/ExpandableChangePasswordForm/ExpandableChangePasswordForm';
import { FormGroup } from 'record-it-components/form/FormGroup/FormGroup';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { BufferedTextInput } from 'record-it-components/input/TextInput/TextInput';
import { SingleTabEditDialog, SingleTabEditDialogProps } from 'record-it-components/modal/SingleTabEditDialog/SingleTabEditDialog';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { EntityName } from 'record-it-time-common/EntityName';
import { ApiAdapter } from '../../../classes/ApiAdapter/ApiAdapter';
import { useEntityPropertyChangedCallback } from '../../../hooks/entity/useEntityPropertyChangedCallback';
import { useModifyEntityCallback } from '../../../hooks/entity/useModifyEntityCallback';
import { useCurrentUser } from '../../../hooks/useCurrentUser';
export type UserProfileDialogProps = PropsWithoutChildren<Omit<SingleTabEditDialogProps, 'tabTitle'>>;
export const UserProfileDialog: FunctionComponent<UserProfileDialogProps> = React.memo(props => {
  const $ = _c(21);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let remainingProps;
  if ($[2] !== t0) {
    ({
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = remainingProps;
  } else {
    remainingProps = $[3];
  }
  const {
    t
  } = useTranslation();
  const {
    getRequiredCurrentUser
  } = useCurrentUser();
  let t1;
  if ($[4] !== getRequiredCurrentUser) {
    t1 = getRequiredCurrentUser();
    $[4] = getRequiredCurrentUser;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const currentUser = t1;
  const modifyUser = useModifyEntityCallback(EntityName.User);
  const handleUserNameChanged = useEntityPropertyChangedCallback(currentUser, "name", modifyUser);
  const changePassword = useEventCallback(_temp);
  let t2;
  if ($[6] !== t) {
    t2 = t("components.user.UserProfileDialog.title");
    $[6] = t;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t) {
    t3 = t("entities.User.name");
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== currentUser.name || $[11] !== handleUserNameChanged || $[12] !== t3) {
    t4 = <FormGroup><BufferedTextInput label={t3} value={currentUser.name} onInput={handleUserNameChanged} data-testid="UserProfileDialog.NameInput" /></FormGroup>;
    $[10] = currentUser.name;
    $[11] = handleUserNameChanged;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== changePassword) {
    t5 = <FormGroup><ExpandableChangePasswordForm changePassword={changePassword} data-testid="UserProfileDialog.ExpandableChangePasswordForm" /></FormGroup>;
    $[14] = changePassword;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== remainingProps || $[17] !== t2 || $[18] !== t4 || $[19] !== t5) {
    t6 = <SingleTabEditDialog {...remainingProps} tabTitle={t2}>{t4}{t5}</SingleTabEditDialog>;
    $[16] = remainingProps;
    $[17] = t2;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
});
async function _temp(t0) {
  const {
    currentPassword,
    newPassword
  } = t0;
  const response = await ApiAdapter.changePassword({
    currentPassword,
    newPassword
  });
  if (!response.success) {
    throw new Error("got unsuccessful response");
  }
}